import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { CustomHttpHeaders } from 'cl-common-angular';

import { BehaviorSubject, of, Subject } from 'rxjs';
import { switchMap, take, tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AvatarService {

    private readonly routePrefix: string = 'api/avatar';

    private avatarSubject$ = new BehaviorSubject<string>('');
    public avatar$ = this.avatarSubject$.asObservable();

    private profileAvatar$ = new Subject<string>();

    constructor(private httpClient: HttpClient) { }

    public loadAvatar = () => this.httpClient.get(this.routePrefix, {
        headers: new HttpHeaders({ [CustomHttpHeaders.disableSpinner]: 'Y' }),
        responseType: 'blob'
    }).pipe(
        tap(blob => {
            const fileReader = new FileReader();
            fileReader.onloadend = () => this.avatarSubject$.next(fileReader.result as string);
            fileReader.readAsDataURL(blob);
        }),
        take(1),
    ).subscribe()

    getInitials(displayName: string): string {
        const nameParts = displayName.split(' ');
        let result = nameParts[0][0];
        if (nameParts.length > 1)
            result += nameParts[nameParts.length - 1][0];
        return result;
    }

    getUserAvatar = (userId?: string | null) => {
        if (!userId) return of(null);
        return this.downloadAvatar(userId)
            .pipe(
                tap(blob => this.readBlob(blob)),
                switchMap(() => this.profileAvatar$.asObservable())
            );
    }

    private readBlob(blob: Blob) {
        if (blob && blob.size > 0) {
            const reader = new FileReader();
            reader.onloadend = () => {
                if (reader.result != null)
                    this.profileAvatar$.next(reader.result.toString());
            };
            reader.readAsDataURL(blob);
        }
    }

    private downloadAvatar = (userId: string) =>
        this.httpClient.get(`${this.routePrefix}/${userId}`, {
            headers: new HttpHeaders({ [CustomHttpHeaders.disableSpinner]: 'Y' }),
            responseType: 'blob'
        })

}
